import React, { FormEvent } from 'react';
import { CheckboxProps, Checkbox } from 'semantic-ui-react';

export interface Props {
  items: CheckboxProps[];
  onChange?: (_: FormEvent<HTMLInputElement>, data: CheckboxProps) => void;
  displayCheckboxAll?: CheckboxProps;
}

export const POSCheckboxList = (props: Props) => {
  return (
    <>
      {props.displayCheckboxAll && (
        <div>
          <Checkbox {...props.displayCheckboxAll} onChange={props.onChange} />
        </div>
      )}
      {props.items.map((checkboxProps, index) => {
        return (
          <div key={index}>
            <Checkbox {...checkboxProps} onChange={props.onChange} />
          </div>
        );
      })}
    </>
  );
};
